module.exports = __webpack_public_path__ + "static/logo-389bffd6caeb5526780db18972290e04.png";